import React from 'react'
import { useSelector } from 'react-redux'

import { AMAZON_SELLER_KEYS_SYNC_STEPS } from 'constants/account'

import { TutorialStep } from './common/TutorialStep'
import { SellerAccountError } from './SellerAccountError'
import { SellerAccountSync } from './SellerAccountSync'
import { SellerAccountSetup } from './SellerAccountSetup'
import { SellerAccountLoading } from './SellerAccountLoading'

export const SellerAccountSyncSteps = () => {
  const {
    ui: { activeModal, previousModal }
  } = useSelector(state => state.sellerAccountSync)

  switch (activeModal) {
    case AMAZON_SELLER_KEYS_SYNC_STEPS.tutorialModal:
      return <TutorialStep previousModal={previousModal} />
    case AMAZON_SELLER_KEYS_SYNC_STEPS.accountSync:
      return <SellerAccountSync />
    case AMAZON_SELLER_KEYS_SYNC_STEPS.accountSetup:
      return <SellerAccountSetup />
    case AMAZON_SELLER_KEYS_SYNC_STEPS.setupError:
      return <SellerAccountError />
    case AMAZON_SELLER_KEYS_SYNC_STEPS.setupLoading:
      return <SellerAccountLoading />
    default:
      return null
  }
}
